import { defineMessages } from 'react-intl';
import globalMessages from '../../../utils/globalMessages';

export default defineMessages({
    ...globalMessages,

    valueConversion: {
        id: 'dashboard.valueConversion',
        defaultMessage: 'Transactions By Method Payment',
    },
});
